import type { FunctionalComponent } from "vue"
import type { ErrorComponentProps } from "vue-utils"

export const Error: FunctionalComponent<ErrorComponentProps> = ({ reload, error }) => (
	<div style="padding: 0.5rem">
		<h2>Error</h2>
		<p>{error.message}</p>
		<br />

		<button class="btn btn-danger" onClick={() => void reload()}>
			Reload
		</button>
	</div>
)
